<template>
  <el-dialog
    title="账号密码登录"
    :visible.sync="dialogVisible"
    width="460px"
    custom-class="login-dialog"
    :before-close="closeDialog">
    <div class="login-container" style="height: 300px;">
      <div class="con-box" content="center" style="right: 6%;position: absolute;">
        <div style="margin-top: 20px;">
          <!--<span>账号密码登录</span>-->
        </div>
        <div>
          <el-form status-icon class="demo-ruleForm" style="padding: 10px 50px;">
            <el-form-item>
              <el-input type="text" v-model="userName" placeholder="手机号／客户编号"></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
              <el-input type="password" v-model="userPassword" placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="login" style="width: 100%;" :disabled="disabledLoginBtn">登录
              </el-button>
            </el-form-item>
            <div style="display: flex;flex-direction: row">
              <el-form-item>
                <el-button type="text" @click="register">立即注册</el-button>
              </el-form-item>
              <el-form-item style="margin-left: 185px;">
                <el-button type="text" @click="forgetPassword">忘记密码</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ct from '../../utils/constant.js'
import { mapMutations } from 'vuex'
import md5 from 'js-md5'
import { setStorage } from '../../utils/utils.js'
export default {
  props: ['dialogVisible'],
  data () {
    return {
      userName: '',
      userPassword: ''
    }
  },
  methods: {
    ...mapMutations(['setFilesList', 'setTagsList', 'setFileUploadingList', 'setSrcPage', 'setCustomerInfo']),
    closeDialog () {
      this.$emit('closeLoginDialog')
    },
    register () {
      this.closeDialog()
      this.$router.push(ct.RouterData.register.path)
    },
    forgetPassword () {
      this.closeDialog()
      this.$router.push(ct.RouterData.forgetPass.path)
    },
    login () {
      let param = {
        'LoginId': this.userName,
        'Password': md5(this.userPassword).toUpperCase()
      }
      this.postRequest('gcwwwifc/login', param).then(res => {
        if (res && res.data.code === 0) {
          setStorage('user', res.data.result)
          this.setCustomerInfo(res.data.result)
          this.getRequest('loadLoginInfo').then(res => {
            if (res && res.data.code === 0) {
              window.getHomeData()
              let data = res.data.result
              this.getSysInfo(data)
              if (this.srcPage !== null) {
                this.setSrcPage(ct.SrcPage.all)
              }
              this.closeDialog()
            }
          })
        }
      })
    }
  },
  computed: {
    disabledLoginBtn () {
      return this.userName === '' || this.userPassword === ''
    }
  }
}
</script>
<style>
  .login-dialog {
    height: 420px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/LoginDialog.vue